import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../../api/pdfSign_api";

export const uploadPdfAction = createAsyncThunk(
  "pdfSign/uploadPdf",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.uploadPDF_api(formData);
      if (response.error) return rejectWithValue(response.error);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to upload PDF");
    }
  }
);

export const detectPlaceholdersAction = createAsyncThunk(
  "pdfSign/detectPlaceholders",
  async (identifier, { rejectWithValue }) => {
    try {
      const response = await api.detectPlaceholders_api(identifier);
      if (response.error) return rejectWithValue(response.error);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to detect placeholders");
    }
  }
);

export const verifySignatureAction = createAsyncThunk(
  "pdfSign/verifySignature",
  async (identifier, { rejectWithValue }) => {
    try {
      const response = await api.verifySignature_api(identifier);
      if (response.error) return rejectWithValue(response.error);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to verify signature");
    }
  }
);

export const getAuditLogsAction = createAsyncThunk(
  "pdfSign/getAuditLogs",
  async (_, { rejectWithValue }) => {
    try {
      return [];
    } catch (err) {
      return rejectWithValue("Audit table removed");
    }
  }
);

export const cancelSessionAction = createAsyncThunk(
  "pdfSign/cancelSession",
  async (sessionId, { rejectWithValue }) => {
    try {
      const response = await api.cancelSession_api(sessionId);
      if (response.error) return rejectWithValue(response.error);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to cancel session");
    }
  }
);
